import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IListStores {
  locationName: string;
  locationNameFrench?: string;
  permalink?: string;
  storeNumber: number;
  _geoloc: {
    lat: string;
    lng: string;
  };
  address: {
    address1: string;
    address2?: string;
    intersection?: string;
    city: string;
    province: string;
    postalCode: string;
  };
  management: {
    authorityType: string;
    storeManager: string;
    storeOwner?: string;
    storeManagerPhoto?: string;
  };
  phoneDetails: {
    phone: string;
    phone2?: string;
    fax?: string;
  };
  email?: string;
  hours: {
    is24Hours: boolean;
    storeHours: Record<string, string>; // Dynamic store hours
    holidayHours: any;
  };
  objectID: string;
  region: string[];
  [key: string]: unknown; // To handle dynamic fields
  specialHours: any;
  continuingCarePharmacy:string[]
}

export interface otherStoreInfo {
  isDropdownOpen: boolean;
}

export const listStoreSlice = createSlice({
  name: "listStore",
  initialState: {
    data: [] as IListStores[], // Store list is initially empty
    pageIndex: 0, // Default page index
  },
  reducers: {
    // Action to set the store list
    setListStore(state, action: PayloadAction<IListStores[]>) {
      state.data = action.payload;
    },
    // Action to reset the store list
    resetListStore(state) {
      state.data = [];
    },
    // Action to set a new page index
    setPageIndex(state, action: PayloadAction<number>) {
      state.pageIndex = action.payload; // Update pageIndex
    },
  },
});

export const selectedStoreSlice = createSlice({
  name: "selectedStore",
  initialState: {
    data: {}, // Selected store, initially null
  },
  reducers: {
    // Action to set the selected store
    setSelectedStore(state, action: PayloadAction<IListStores>) {
      state.data = action.payload;
    },
    // Action to reset the selected store to null
    resetSelectedStore(state) {
      state.data = {};
    },
  },
});

export const otherStoreInfo = createSlice({
  name: "otherStoreInfo",
  initialState: {
    isDropdownOpen: false,
  },
  reducers: {
    // Action to set the selected store
    setOtherStoreInfo(state, action: PayloadAction<otherStoreInfo>) {
      state.isDropdownOpen = action.payload.isDropdownOpen;
    },
  },
});
export const storeAemData = createSlice({
  name: "storeAemData",
  initialState: {
    storeAemData: null,
  },
  reducers: {
    // Action to set the storeAemData
    setStoreAemData(state, action: PayloadAction<any>) {
      state.storeAemData = action.payload.storeAemData;
    },
  },
});
// Export actions and reducer for store list
export const { setListStore, resetListStore, setPageIndex } =
  listStoreSlice.actions;
export const listStoreReducer = listStoreSlice.reducer;

// Export actions and reducer for selected store
export const { setSelectedStore, resetSelectedStore } =
  selectedStoreSlice.actions;
export const selectedStoreReducer = selectedStoreSlice.reducer;

// Export actions and reducer for selected store
export const { setOtherStoreInfo } = otherStoreInfo.actions;
export const otherStoreInfoReducer = otherStoreInfo.reducer;

// Export actions and reducer for selected store
export const { setStoreAemData } = storeAemData.actions;
export const storeAemDataReducer = storeAemData.reducer;
